/**
 * Check if two arrays contain the same items.
 * Items do *not* need to be in the same order.
 *
 *   isSameSet([1, 2, 3], [3, 2, 1]) // true
 */
export default (function (arr1, arr2) {
    return arr1.length === arr2.length && arr1.every(function (item) { return arr2.includes(item); });
});



//////////////////
// WEBPACK FOOTER
// ./~/@reecelucas/react-use-hotkeys/esm/helpers/isSameSet.js
// module id = 663
// module chunks = 0